module.exports = __webpack_public_path__ + "static/media/tachometer-fast.5b2068a3.svg";